import type { AuthUser } from "@/transport/auth"
import { createJSONStorage } from "./browser"

// Disposable cache: the account this device last verified with the control
// plane. A returning device that still holds a session opens as that account
// while the control plane confirms it. It is under the device's owner record
// (workspace-owner.ts), so another account's claim removes it.
const storage = createJSONStorage<AuthUser | undefined>("mux.auth.verifiedUser", {
  decode(value) {
    if (!value || typeof value !== "object") return undefined
    const user = value as Partial<AuthUser>
    return typeof user.id === "string" && typeof user.email === "string" && typeof user.display_name === "string" &&
      typeof user.created_at === "number" && typeof user.updated_at === "number"
      ? user as AuthUser
      : undefined
  },
})

export function readVerifiedUser() {
  return storage.read(undefined)
}

export function writeVerifiedUser(user: AuthUser | undefined) {
  if (user) storage.write(user)
  else storage.remove()
}
